import React, { useRef } from 'react';
import cl from 'classnames';
import { SearchOutlined } from '@ant-design/icons';
import { HexToRGB } from '@/utils/utils';
import { openConfiguredLink } from '@/utils/navigation';
import Clickable from '@/components/Clickable';

function PageBuilderNavigationBar({
  styles,
  defaultBackIcon,
  titleBoldWeight = 600,
  visible,
  topMargin,
  headerName,
  hasSearchBox,
  searchLink,
  contentFontSize,
  contentFontColor,
  contentFontColorOpacity,
  isContentFontBold,
  isContentFontItalic,
  iconColor,
  iconColorOpacity,
  hasBg,
  backIcon,
  bgType,
  bgColor,
  bgColorOpacity,
  bgImg,
  fontFamily = 'Roboto',
}) {
  const navBar = useRef(null);
  const titleStyles = {
    fontSize: `${Number(contentFontSize) / 100}rem`,
    color: HexToRGB(contentFontColor, contentFontColorOpacity),
    fontWeight: isContentFontBold === 'Y' ? titleBoldWeight : 'normal',
    fontFamily,
    fontStyle: isContentFontItalic === 'Y' ? 'italic' : 'normal',
  };

  const iconStyle = {
    color: HexToRGB(iconColor, iconColorOpacity),
  };

  const bgStyle = {
    marginTop: `${Number(topMargin) / 100}rem`,
    backgroundColor:
      hasBg === 'Y' && bgType === 'Color' ? HexToRGB(bgColor, bgColorOpacity) : 'transparent',
    backgroundImage: hasBg === 'Y' && bgType === 'Image' ? `url(${bgImg?.src})` : 'initial',
    backgroundSize: '100%',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
  };

  const onBackClick = () => {
    window.clp?.goBackHome();
  };

  return (
    <div
      className={cl(styles.carouselBox, {
        hidden: !visible,
      })}
      style={{ overflow: 'auto' }}
    >
      <div className={styles.navheader} style={bgStyle} ref={navBar}>
        <Clickable className={styles.navBack} style={iconStyle} onClick={onBackClick}>
          <img src={backIcon?.[0]?.src || defaultBackIcon} alt="" />
        </Clickable>
        <div style={titleStyles}>{headerName}</div>
        {hasSearchBox ? (
          <Clickable
            className={cl(styles.navSearch, { hidden: !hasSearchBox })}
            style={iconStyle}
            onClick={() => openConfiguredLink(searchLink)}
          >
            <SearchOutlined />
          </Clickable>
        ) : (
          <span>{}</span>
        )}
      </div>
    </div>
  );
}

export default PageBuilderNavigationBar;
